import type { PlcManufacturerCodeLibrary } from "./types";

export const schneiderCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "schneider",
  manufacturer_name: "Schneider Electric",
  codes: [
    {
      id: "schneider-m221-err-led-red",
      manufacturer_id: "schneider",
      series_id: "modicon-m221",
      model: null,
      code: "ERR LED: RED",
      code_type: "LED",
      title_ar: "Modicon M221 Module Error",
      description_ar: "إضاءة ERR بالأحمر على M221 تدل على Module Error وتحتاج قراءة التشخيص من EcoStruxure Machine Expert - Basic.",
      symptoms: ["ERR LED أحمر", "الكنترولر أو جزء من تكوينه بيه خطأ"],
      causes: ["Module error", "Configuration أو hardware issue يحتاج تشخيص"],
      checks: [
        {
          step: 1,
          action: "اتصل بالـM221 من Machine Expert - Basic واقرأ حالة الكنترولر.",
          expected: "ماكو Error فعال.",
          faulty: "يظهر Error/Diagnostic مرتبط بالموديول أو الكنترولر.",
        }
      ],
      solutions: ["عالج التشخيص الظاهر بالبرنامج.", "قارن التوصيلات والتكوين بالمشروع."],
      severity: "عالية",
      source_title: "Schneider Electric Modicon M221 product documentation",
      source_section: "Product indicator: red ERR LED for module error",
      keywords: ["Schneider", "Modicon", "M221", "ERR LED"],
    },  ],
};
